import React from 'react';
import MemberTableHeader from './MemberTableHeader';
import MemberTableRow from './MemberTableRow';
import Icon from '../../../components/AppIcon';


const MemberTable = ({ 
  members, 
  sortConfig, 
  onSort, 
  selectedMembers, 
  onSelectMember, 
  onSelectAll,
  onEditMember,
  onDeleteMember,
  onViewMemberDetails 
}) => {
  const allSelected = members?.length > 0 && selectedMembers?.length === members?.length;
  const selectedCount = selectedMembers?.length;

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <MemberTableHeader
            sortConfig={sortConfig}
            onSort={onSort}
            allSelected={allSelected}
            onSelectAll={onSelectAll}
            totalMembers={members?.length}
            selectedCount={selectedCount}
          />
          <tbody>
            {members?.map((member) => (
              <MemberTableRow
                key={member?.id}
                member={member}
                isSelected={selectedMembers?.includes(member?.id)}
                onSelect={onSelectMember}
                onEdit={onEditMember}
                onDelete={onDeleteMember}
                onViewDetails={onViewMemberDetails}
              />
            ))}
          </tbody>
        </table>
      </div>
      {members?.length === 0 && (
        <div className="text-center py-12">
          <div className="text-muted-foreground">
            <div className="mb-4">
              <Icon name="Users" size={48} className="mx-auto opacity-50" />
            </div>
            <h3 className="text-lg font-medium mb-2">Nenhum membro encontrado</h3>
            <p className="text-sm">Tente ajustar sua busca ou filtros</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberTable;